import { render, staticRenderFns } from "./ProblemRectificationList.vue?vue&type=template&id=0e9565c7&scoped=true&"
import script from "./ProblemRectificationList.vue?vue&type=script&lang=js&"
export * from "./ProblemRectificationList.vue?vue&type=script&lang=js&"
import style0 from "./ProblemRectificationList.vue?vue&type=style&index=0&id=0e9565c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9565c7",
  null
  
)

export default component.exports